import { defineComponent as _defineComponent } from 'vue'
import bugsnagClient from 'JS/global/bugsnag';
import RewardsSideMenuContents from './components/RewardsSideMenuContents.vue';
import SideMenu from 'Src/js/components/SideMenu.vue';
import SideMenuHeaderButton from '../SideMenuHeaderButton.vue';
import Spinner from 'JS/components/Spinner.vue';
import { checkWebpFeature } from 'JS/global/images';
import { computed, ref } from 'vue';
import { CreateOauthAccountRequest, IAuthenticateError, IAuthenticateResponse, ICreateAccountResource, ICreateAccountResponse, LoginMethod } from 'JS/types/Account';
import { onMounted, PropType, watch } from 'vue';
import { IJoinRewardsStep, IVerifyUserData } from 'JS/types/rewards';
import { provideServices } from '../composables/services';


export default /*#__PURE__*/_defineComponent({
  __name: 'RewardsSignupSidePanel',
  props: {
	show: {
		type: Boolean
	},
	step: {
		type: String as PropType<IJoinRewardsStep>,
		default: "join",
		required: false
	},
	isFullScreenPage: {
		type: Boolean,
		default: false,
		required: false,
	},
	destinationUrl: {
		type: String,
		required: false,
	},
	userVerificationData: {
		type: Object as PropType<IVerifyUserData>,
		required: false,
	},
	createAccountRequest: {
		type: Object as PropType<ICreateAccountResource>,
		required: false,
	},
	createOauthAccountRequest: {
		type: Object as PropType<CreateOauthAccountRequest>,
		required: false,
	},

},
  emits: ["close"],
  setup(__props, { emit }: { emit: ({
	(e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

const { accountService } = provideServices();





const forceReload = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const joinRewardsStep = ref<IJoinRewardsStep>(null);
const backArrowRouter = ref<Array<IJoinRewardsStep>>([]);
const createAccountErrorMessage = ref<string>("");
const antiForgeryToken = ref("");

const showBackArrow = computed((): boolean => {
	return backArrowRouter.value.length != 0;
});

function updateSideMenuHeaderButton(prevPage: IJoinRewardsStep | "clear") {
	if (prevPage === "clear") {
		backArrowRouter.value = [];
	} else {
		backArrowRouter.value.push(prevPage);
	}
}

function handleBackArrow() {
	joinRewardsStep.value = backArrowRouter.value.pop();
}

function determineClose(fromCloseButton: boolean = false) {
	if (fromCloseButton && props.isFullScreenPage) {
		skipConnectingRewards();
	} else {
		if (forceReload.value || props.isFullScreenPage) {
			if (props.destinationUrl) {
				window.location.href = props.destinationUrl;
			} else {
				window.location.reload();
			}
		}
		emit('close');
	}
}

function handleIsLoading(value: boolean) {
	isLoading.value = value;
}

function reset() {
	backArrowRouter.value = [];
	joinRewardsStep.value = props.step;
}

async function skipConnectingRewards() {
	if (!props.createAccountRequest && !props.createOauthAccountRequest) {
		determineClose();
		return;
	}

	try {
		isLoading.value = true;
		if (props.createAccountRequest) {
			await attemptCreateAccount();
		} else {
			await attemptCreateOauthAccount();
		}
	} catch (err) {
		createAccountErrorMessage.value = "Something went wrong. Please try again later.";
		isLoading.value = false;
		bugsnagClient.notify(err);
	}
}

async function attemptCreateAccount() {
	const result: ICreateAccountResponse = await accountService.createAccount({ ...props.createAccountRequest, skipConnectingRewards: true } , antiForgeryToken.value);
	if (!result?.success) {
		createAccountErrorMessage.value = result.errorMessage;
		isLoading.value = false;
	} else {
		window.blainGtmDataLayer.push({
			'event': "create_login",
			'loginMethod': LoginMethod.Local,
		});
		window.blainGtmDataLayer.push({
			'event': "skipped_connecting_rewards",
			'loginMethod': LoginMethod.Local,
		});

		if (result.headerJson && window.vueEventBus) {
			window.vueEventBus.$emit('header-vm', result.headerJson);
		}
		determineClose();
	}
}

async function attemptCreateOauthAccount() {
	let result: IAuthenticateResponse | IAuthenticateError = null;

	if (props.createOauthAccountRequest.loginMethod === LoginMethod.Apple) {
		result = await accountService.appleLogin(JSON.parse(props.createOauthAccountRequest.credentialToken), props.createOauthAccountRequest.skipCartMerge, true);
	} else if (props.createOauthAccountRequest.loginMethod === LoginMethod.Facebook) {
		result = await accountService.facebookLogin(JSON.parse(props.createOauthAccountRequest.credentialToken), props.createOauthAccountRequest.skipCartMerge, true);
	} else {
		result = await accountService.googleLogin(props.createOauthAccountRequest.credentialToken, props.createOauthAccountRequest.skipCartMerge, true);
	}

	if (!result?.success) {
		if ('error' in result) {
			const errorMessage = `${result.error}`
		+ (result.message ? ` - ${result.message}` : '');
			createAccountErrorMessage.value =
		result.error
			? errorMessage
			: "Something went wrong. Please try again later.";
		}

		isLoading.value = false;
	} else {
		window.blainGtmDataLayer.push({
			'event': "create_login",
			'loginMethod': props.createOauthAccountRequest.loginMethod,
		});
		window.blainGtmDataLayer.push({
			'event': "skipped_connecting_rewards",
			'loginMethod': props.createOauthAccountRequest.loginMethod,
		});
		determineClose();
	}
}

watch(() => props.step, (newPage) =>  {
	joinRewardsStep.value = newPage;
}, { immediate: true });

//Adds this image to the cache so it's pre-loaded before sidepanel opening.
onMounted(() => {
	checkWebpFeature("alpha").then(isSupported => {
		if (isSupported) {
			new Image().src = "/assets/images/rewards/rewards-header-blue-min.webp";
		} else {
			new Image().src = "/assets/images/rewards/rewards-header-blue-min.png";
		}
	});
});


return { __sfc: true,accountService, props, emit, forceReload, isLoading, joinRewardsStep, backArrowRouter, createAccountErrorMessage, antiForgeryToken, showBackArrow, updateSideMenuHeaderButton, handleBackArrow, determineClose, handleIsLoading, reset, skipConnectingRewards, attemptCreateAccount, attemptCreateOauthAccount, RewardsSideMenuContents, SideMenu, SideMenuHeaderButton, Spinner }
}

})